import { Typography } from "@mui/material";

/** COMPONENT */
import TableCustom from "../../../component/table/tableCustom";
import TableRowCommon from "../../../component/table/TableRowCommon";

/** UTILS */
import { OwnerStall } from "../../../api/inheritance-transfer/inheritance-transfer.api";
import { leaseStatusColor, leaseStatusLabel } from "../../../constants/inheritanceTransfer";
import { dateToView } from "../../../utils/date.utils";

type Props = {
  /** ใช้ได้ทั้งข้อมูลสด (GET /owner/:userId/stall) และ snapshot (GET /:id) — field ชุดเดียวกัน */
  stalls: OwnerStall[];
  textEmptyData?: string;
};

/**
 * ตาราง "ข้อมูลแผงค้าของผู้โอน" ใช้ร่วมกันระหว่าง modal สร้างคำร้องกับ modal รายละเอียด
 * ไม่มีการแบ่งหน้าเพราะจำนวนแผงค้าต่อผู้โอน 1 คนมีไม่มาก
 */
export default function StallTable({ stalls, textEmptyData }: Props) {
  const headCells = [
    { id: "documentDate", disablePadding: false, label: "วันที่เอกสาร", align: "left" },
    { id: "leaseAgreementNo", disablePadding: false, label: "เลขที่สัญญา", align: "left" },
    { id: "tenantName", disablePadding: false, label: "ชื่อผู้เข้าแผงค้า", align: "left" },
    { id: "zoneName", disablePadding: false, label: "โซน", align: "left" },
    { id: "stallName", disablePadding: false, label: "แผงค้า", align: "left" },
    { id: "stallNumber", disablePadding: false, label: "เลขแผงค้า", align: "left" },
    { id: "stallTypeName", disablePadding: false, label: "ประเภทแผงค้า", align: "left" },
    { id: "appointmentDate", disablePadding: false, label: "วันที่นัดหมาย", align: "left" },
    { id: "dateStart", disablePadding: false, label: "วันที่เริ่มสัญญา", align: "left" },
    { id: "dateEnd", disablePadding: false, label: "วันที่หมดสัญญา", align: "left" },
    { id: "leaseStatus", disablePadding: false, label: "สถานะ", align: "center" },
  ];

  /** dateToView(undefined) format วันนี้เงียบๆ ต้อง guard ก่อนเสมอ */
  const viewDate = (date?: string | null) => (date ? dateToView(date) : "-");

  const renderData = (objData: OwnerStall, no: number) => {
    const objRenderData = {
      key: `stall-${objData.leaseAgreementId}-${objData.stallId}-${no}`,
      id: `stall-${objData.stallId}`,
      obj: objData,
      columns: [
        { option: "TEXT", align: "left", label: viewDate(objData.document_date) },
        { option: "TEXT", align: "left", label: objData.lease_agreement_no || "-" },
        { option: "TEXT", align: "left", label: objData.tenant_name || "-" },
        { option: "TEXT", align: "left", label: objData.zone_name || "-" },
        { option: "TEXT", align: "left", label: objData.stall_name || "-" },
        { option: "TEXT", align: "left", label: objData.stall_number || "-" },
        { option: "TEXT", align: "left", label: objData.stall_type_name || "-" },
        { option: "TEXT", align: "left", label: viewDate(objData.appointment_date) },
        { option: "TEXT", align: "left", label: viewDate(objData.date_start) },
        { option: "TEXT", align: "left", label: viewDate(objData.date_end) },
        {
          option: "COMPONENT",
          align: "center",
          component: (
            <Typography sx={{ fontSize: 16, color: leaseStatusColor(objData.lease_status) }}>
              {leaseStatusLabel(objData.lease_status)}
            </Typography>
          ),
        },
      ],
    };

    return <TableRowCommon {...objRenderData} />;
  };

  return (
    <TableCustom
      headCells={headCells}
      customScroll
      hidePagination
      page={1}
      pageLimit={stalls.length || 1}
      sortType="ASC"
      sortBy=""
      rowCount={stalls.length}
      rowsData={stalls.map((stall, index) => renderData(stall, index))}
      onSort={() => { }}
      setPage={() => { }}
      setPageLimit={() => { }}
      textEmptyData={textEmptyData}
      tableMinWidth={1300}
      tableMaxHeight={320}
      stickyHeader
    />
  );
}
